/* DESI STEPS — SHARED WISHLIST ENGINE
   Storage: browser localStorage
   Key: desi-steps-wishlist
*/
(function () {
  'use strict';

  if (window.DesiStepsWishlist) return;

  var STORAGE_KEY = 'desi-steps-wishlist';
  var EVENT_NAME = 'desi-steps:wishlist-updated';

  function safeString(value) {
    return value == null ? '' : String(value);
  }

  function normalizeItem(item) {
    if (item == null) return null;

    /* Backward compatibility with the old wishlist that stored only product IDs. */
    if (typeof item === 'string' || typeof item === 'number') {
      return {
        id: safeString(item),
        legacy: true
      };
    }

    if (!item.id) return null;

    return {
      id: safeString(item.id),
      handle: safeString(item.handle),
      title: safeString(item.title),
      url: safeString(item.url),
      image: safeString(item.image),
      price: Number(item.price || 0),
      compareAtPrice: Number(item.compareAtPrice || 0),
      variantId: safeString(item.variantId),
      variantTitle: safeString(item.variantTitle),
      available: item.available !== false,
      addedAt: item.addedAt || Date.now(),
      legacy: item.legacy === true
    };
  }

  function read() {
    var raw = [];

    try {
      raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      raw = [];
    }

    if (!Array.isArray(raw)) raw = [];

    var seen = {};
    var normalized = [];

    raw.forEach(function (item) {
      var clean = normalizeItem(item);
      if (!clean || !clean.id || seen[clean.id]) return;
      seen[clean.id] = true;
      normalized.push(clean);
    });

    return normalized;
  }

  function emit(items) {
    var list = Array.isArray(items) ? items : read();

    try {
      document.dispatchEvent(new CustomEvent(EVENT_NAME, {
        detail: {
          items: list,
          count: list.length
        }
      }));
    } catch (error) {}
  }

  function write(items) {
    var clean = [];
    var seen = {};

    (Array.isArray(items) ? items : []).forEach(function (item) {
      var normalized = normalizeItem(item);
      if (!normalized || !normalized.id || seen[normalized.id]) return;
      seen[normalized.id] = true;
      clean.push(normalized);
    });

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
    } catch (error) {}

    emit(clean);
    return clean;
  }

  function indexOfId(items, id) {
    var target = safeString(id);
    return items.findIndex(function (item) {
      return safeString(item.id) === target;
    });
  }

  function getAll() {
    return read();
  }

  function count() {
    return read().length;
  }

  function contains(id) {
    return indexOfId(read(), id) !== -1;
  }

  function get(id) {
    var items = read();
    var index = indexOfId(items, id);
    return index === -1 ? null : items[index];
  }

  function add(item) {
    var clean = normalizeItem(item);
    if (!clean || !clean.id) return read();

    var items = read();
    var index = indexOfId(items, clean.id);

    if (index === -1) {
      clean.addedAt = clean.addedAt || Date.now();
      items.unshift(clean);
    } else {
      clean.addedAt = items[index].addedAt || clean.addedAt || Date.now();
      items[index] = clean;
    }

    return write(items);
  }

  function update(item) {
    var clean = normalizeItem(item);
    if (!clean || !clean.id) return read();

    var items = read();
    var index = indexOfId(items, clean.id);
    if (index === -1) return items;

    clean.addedAt = items[index].addedAt || clean.addedAt || Date.now();
    items[index] = clean;
    return write(items);
  }

  function remove(id) {
    var target = safeString(id);
    return write(read().filter(function (item) {
      return safeString(item.id) !== target;
    }));
  }

  function toggle(item) {
    var clean = normalizeItem(item);
    if (!clean || !clean.id) return { saved: false, items: read() };

    if (contains(clean.id)) {
      return { saved: false, items: remove(clean.id) };
    }

    return { saved: true, items: add(clean) };
  }

  function clear() {
    return write([]);
  }

  window.DesiStepsWishlist = {
    key: STORAGE_KEY,
    eventName: EVENT_NAME,
    getAll: getAll,
    get: get,
    count: count,
    contains: contains,
    add: add,
    update: update,
    remove: remove,
    toggle: toggle,
    clear: clear,
    refresh: function () { emit(read()); }
  };

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) emit(read());
  });

  /* Give header/page components an initial count immediately. */
  setTimeout(function () { emit(read()); }, 0);
})();
